<template>
    <validation-provider
        :name="name"
        v-slot="{ errors, invalid, failed, changed, validated }"
        :rules="rules"
        ref="dropdownValidator"
    >
        <div class="form-element-container">
            <div
                :class="{
                    ['form-element input input-error ' + `${computedClasses}`]:
                        failed && (changed || validated),
                    ['form-element input ' + `${computedClasses}`]: !(
                        failed &&
                        (changed || validated)
                    ),
                }"
            >
                <label :for="inputId" v-html="label"></label>

                <Dropdown
                    :inputId="inputId"
                    :id="inputId"
                    v-model="selectedValue"
                    :options="options"
                    :optionLabel="optionLabel"
                    :class="'dropdown ' + `${computedClasses}`"
                    @hide="dropdownHidden"
                />
            </div>

            <p class="error-text" v-if="failed && (changed || validated)">
                {{ errorMessage }}
            </p>
        </div>
    </validation-provider>
</template>

<script>
import Dropdown from 'primevue/dropdown';

export default {
    components: {
        Dropdown,
    },
    props: {
        inputId: {
            type: String,
            required: true,
        },
        name: {
            type: String,
            required: true,
        },
        label: {
            type: String,
            default: 'Title',
        },
        rules: {
            type: String,
            default: '',
        },
        options: {
            type: Array,
            required: true,
        },
        optionLabel: {
            type: String,
            default: '',
        },
        value: {
            type: [String, Object, null],
            default: null,
        },
        additionalClass: {
            type: String,
            default: '',
        },
        errorMessage: {
            type: String,
            default: '',
        },
    },
    computed: {
        selectedValue: {
            get() {
                return this.value;
            },
            set(value) {
                this.$emit('input', value);
            },
        },
        computedClasses() {
            return [this.additionalClass];
        },
    },
    methods: {
        dropdownHidden() {
            this.$refs.dropdownValidator.validate();
        },
    },
};
</script>
